import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import * as $ from "jquery";
class EquipmentAreaTab extends GenericListSearchTab {
    SearchType(): string {
        return "Area";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
}
export default EquipmentAreaTab;